//
// Small info button that toggles an information tooltip on click.
//
import PropTypes from 'prop-types';
import { useId } from 'react';
import { Tooltip } from 'react-tooltip';

import { useTownAssets } from '../../stores';
import { Button } from '../buttons';

const InfoPopup = function InfoPopup(props) {
  const {
    infoIdArray,
  } = props;
  const { assets } = useTownAssets();
  const {
    translate,
  } = assets;
  const tooltipId = useId();

  return (
    <>
      <span data-tooltip-id={tooltipId}>
        <Button
          imgSrc="/images/svg/gui/infoCircle.svg"
          noFrame
          tiny
          onClick={() => {}}
        />
      </span>

      <Tooltip
        id={tooltipId}
        place="top"
        positionStrategy="fixed"
        openOnClick
        clickable
        className="font-semibold"
      >
        <div className="flex flex-col gap-2 max-w-[520px] text-justify">
          { infoIdArray.map((id) => (
            <span key={id}>
              {translate(id, 'uiInfo')}
            </span>
          )) }
        </div>
      </Tooltip>
    </>
  );
};

InfoPopup.propTypes = {
  infoIdArray: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default InfoPopup;
